/**
 * Helpers para montar `postFilters` do export CSV em background (export/tablecsv).
 * `postFilters` é aplicado pelo worker (export_table_csv.py) sobre a resposta do
 * `listEndpoint`, espelhando as mesmas regras do MerusDataTable.filteredItems:
 *  - string ou { contains } -> "contains" case-insensitive
 *  - { from, to } -> intervalo de datas
 *  - { notNull: true } -> valor do campo não é null
 *  - { in: [...] } -> valor do campo está na lista (campos array casam por interseção)
 *  - { eq } -> igualdade
 */

/** Converte o `multiSearch` (colunas) do MerusDataTable para o formato de `postFilters`. */
export function multiSearchToPostFilters(multiSearch) {
  const out = {};
  if (!multiSearch || typeof multiSearch !== 'object') {
    return out;
  }
  Object.keys(multiSearch).forEach((key) => {
    const value = multiSearch[key];
    if (value == null) return;
    if (typeof value === 'object' && !Array.isArray(value)) {
      const from = value.from != null && String(value.from).trim() !== '' ? String(value.from).trim() : null;
      const to = value.to != null && String(value.to).trim() !== '' ? String(value.to).trim() : null;
      if (from || to) {
        out[key] = {};
        if (from) out[key].from = from;
        if (to) out[key].to = to;
      }
      return;
    }
    const s = String(value).trim();
    if (s !== '') {
      out[key] = s;
    }
  });
  return out;
}

/** `{ [field]: { in: values } }`, ou `{}` quando `values` está vazio (nada a filtrar). */
export function inFilter(field, values) {
  if (!field || !Array.isArray(values) || values.length === 0) {
    return {};
  }
  return { [field]: { in: values } };
}

/** `{ [field]: { eq: value } }`, ou `{}` quando `value` é nulo/vazio. */
export function eqFilter(field, value) {
  if (!field || value == null || value === '') {
    return {};
  }
  return { [field]: { eq: value } };
}

/** `{ [field]: { contains: value } }`, ou `{}` quando `value` é vazio. */
export function containsFilter(field, value) {
  const s = value == null ? '' : String(value).trim();
  if (!field || !s) {
    return {};
  }
  return { [field]: { contains: s } };
}

/** `{ [field]: { from, to } }`, ou `{}` quando ambos estão vazios. */
export function dateRangeFilter(field, from, to) {
  const f = from != null && String(from).trim() !== '' ? String(from).trim() : null;
  const t = to != null && String(to).trim() !== '' ? String(to).trim() : null;
  if (!field || (!f && !t)) {
    return {};
  }
  const spec = {};
  if (f) spec.from = f;
  if (t) spec.to = t;
  return { [field]: spec };
}

/** `{ [field]: { notNull: true } }`, ou `{}` quando `field` está vazio. */
export function notNullFilter(field) {
  if (!field) {
    return {};
  }
  return { [field]: { notNull: true } };
}

/** Mescla vários objetos `postFilters` (o último a definir um campo vence). */
export function mergePostFilters(...objs) {
  const out = {};
  objs.forEach((obj) => {
    if (obj && typeof obj === 'object') {
      Object.keys(obj).forEach((key) => {
        if (obj[key] != null) out[key] = obj[key];
      });
    }
  });
  return out;
}
